import { createBrowserRouter, Navigate } from "react-router-dom";

import { Shell } from "@/layout/Shell";
import { ActivatePage } from "@/pages/ActivatePage";
import { AdminDashboardPage } from "@/pages/AdminDashboardPage";
import { ApprovalsPage } from "@/pages/ApprovalsPage";
import { BoardPage } from "@/pages/BoardPage";
import { FillTimesheetPage } from "@/pages/FillTimesheetPage";
import { ForgotPasswordPage } from "@/pages/ForgotPasswordPage";
import { IssueDetailPage } from "@/pages/IssueDetailPage";
import { LoginPage } from "@/pages/LoginPage";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage";
import { MembersPage } from "@/pages/MembersPage";
import { MyBoardPage } from "@/pages/MyBoardPage";
import { MyProgressPage } from "@/pages/MyProgressPage";
import { NotFoundPage } from "@/pages/NotFoundPage";
import { OnboardingPage } from "@/pages/OnboardingPage";
import { OnboardProfilePage } from "@/pages/OnboardProfilePage";
import { RoomsPage } from "@/pages/RoomsPage";
import { SuperAdminDashboardPage } from "@/pages/SuperAdminDashboardPage";
import { SuperAdminOnboardingPage } from "@/pages/SuperAdminOnboardingPage";
import { SuperAdminTenantDetailPage } from "@/pages/SuperAdminTenantDetailPage";
import { AssignProjectPage } from "@/pages/superadmin/AssignProjectPage";
import { AtlasAnalyticsPage } from "@/pages/superadmin/AtlasAnalyticsPage";
import { AtlasCallTracesPage } from "@/pages/superadmin/AtlasCallTracesPage";
import { AtlasErrorsPage } from "@/pages/superadmin/AtlasErrorsPage";
import { CreateProjectPage } from "@/pages/superadmin/CreateProjectPage";
import { ExistingProjectsProgressPage } from "@/pages/superadmin/ExistingProjectsProgressPage";
import { TimesheetDashboardPage } from "@/pages/TimesheetDashboardPage";
import { TimesheetPage } from "@/pages/TimesheetPage";
import { UserSettingsPage } from "@/pages/UserSettingsPage";
import { WikiListPage } from "@/pages/WikiListPage";
import { WikiPagePage } from "@/pages/WikiPagePage";
import { RequireAuth } from "@/routes/RequireAuth";

export const router = createBrowserRouter([
  { path: "/login", element: <LoginPage /> },
  { path: "/forgot", element: <ForgotPasswordPage /> },
  { path: "/reset/:token", element: <ResetPasswordPage /> },
  { path: "/activate/:token", element: <ActivatePage /> },
  {
    path: "/",
    element: (
      <RequireAuth>
        <Shell />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/board" replace /> },
      { path: "board", element: <BoardPage /> },
      { path: "board/:projectKey", element: <BoardPage /> },
      { path: "my-board", element: <MyBoardPage /> },
      { path: "issues/:issueKey", element: <IssueDetailPage /> },
      { path: "wiki", element: <WikiListPage /> },
      { path: "wiki/spaces/:spaceSlug", element: <WikiListPage /> },
      { path: "wiki/pages/:pageId", element: <WikiPagePage /> },
      { path: "time", element: <TimesheetPage /> },
      { path: "rooms", element: <RoomsPage /> },
      { path: "me/progress", element: <MyProgressPage /> },
      { path: "settings", element: <UserSettingsPage /> },
      { path: "settings/profile", element: <OnboardProfilePage mode="settings" /> },
      { path: "onboard/profile", element: <OnboardProfilePage /> },
      { path: "approvals", element: <ApprovalsPage /> },
      { path: "admin", element: <AdminDashboardPage /> },
      { path: "admin/timesheets", element: <TimesheetDashboardPage /> },
      { path: "admin/fill-timesheet", element: <FillTimesheetPage /> },
      { path: "members", element: <MembersPage /> },
      { path: "admin/onboarding", element: <OnboardingPage /> },
      { path: "superadmin/dashboard", element: <SuperAdminDashboardPage /> },
      { path: "superadmin/onboarding", element: <SuperAdminOnboardingPage /> },
      { path: "superadmin/projects", element: <CreateProjectPage /> },
      { path: "superadmin/assign", element: <AssignProjectPage /> },
      { path: "superadmin/progress", element: <ExistingProjectsProgressPage /> },
      { path: "superadmin/atlas-errors", element: <AtlasErrorsPage /> },
      { path: "superadmin/atlas-analytics", element: <AtlasAnalyticsPage /> },
      { path: "superadmin/atlas-traces", element: <AtlasCallTracesPage /> },
      { path: "superadmin/tenants/:slug", element: <SuperAdminTenantDetailPage /> },
    ],
  },
  { path: "*", element: <NotFoundPage /> },
]);
